import { useCallback } from "react";
import { useLanguage } from "../context/LanguageContext";

export const useTranslation = () => {
  const { translations } = useLanguage();

  const t = useCallback(
    (key, fallback = "") => {
      if (!translations || typeof translations !== "object") {
        return fallback || key;
      }

      const keys = key.split(".");
      let value = translations;

      for (const k of keys) {
        value = value?.[k];
        if (value === undefined) {
          if (process.env.NODE_ENV === "development") {
            console.warn(`Translation key "${key}" not found`);
          }
          return fallback || key;
        }
      }

      return value;
    },
    [translations]
  );

  return { t };
};
